
/**
 * A string for use with moment().format() that will create the appropriately formatted string
 * @constant {string}
 */
export const MOMENT_FORMAT_STRING = 'YYYY-MM-DDTHH:mm:ssZ';
const UTC_TZ_REGEX = /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}([-+]\d{2}:\d{2}|Z)/;

/**
 * An object representation of a well formatted date and time. Representation is in UTC+TZ
 * Example: 2019-03-25T08:59:58-04:00
 *
 * @param {string|FormattedDateTime} value - Either a well formatted string, or a pre-existing FormattedDateTime. String can use Z instead of +00:00, however the value will be converted internally.
 * @throws {TypeError} - If the value is falsy
 * @throws {Error} - If the string (or object with value property) are not properly formatted
 */
export class FormattedDateTime {
    constructor(value) {
        if (!value) {
            throw new TypeError(`value cannot be falsy. Provided value: ${value}`);
        }

        let possibleFormattedDateTime = value.toString();
        if (typeof value.value === 'string') {
            possibleFormattedDateTime = value.value;
        }

        if (!UTC_TZ_REGEX.test(possibleFormattedDateTime)) {
            throw new Error(`The provided value is not in the correct format. Example: 2019-03-25T08:59:58-04:00. Provided value: ${value}`);
        }

        this.value = possibleFormattedDateTime.replace(/Z$/, '+00:00');

        Object.freeze(this);
    }

    /**
     * @returns {string} The well formatted string of the date time
     */
    toString() {
        return this.value;
    }
}
